'use strict';

// Constants
const DESKTOP_MEDIA_QUERY = '(min-width: 768px)';
const DEFAULT_OPEN_SECTIONS = ['description', 'details'];

let preservedOpenStates = null;

/**
 * Sets the open state for a product attribute section.
 * @param {jQuery} $section - section element
 * @param {boolean} isOpen - whether the section should be open
 */
function setSectionOpen($section, isOpen) {
    if (!$section.length) return;

    const $trigger = $section.find('.product-attribute-section__trigger').first();
    const $panel = $section.find('.product-attribute-section__panel').first();
    const panelId = $panel.attr('id');

    $section.toggleClass('is-open', isOpen);
    $trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
    $panel.prop('hidden', !isOpen);

    if (panelId) $trigger.attr('aria-controls', panelId);
}

/**
 * Resolves section open state from rendered data attributes.
 * @param {jQuery} $sectionsContainer - sections wrapper
 * @param {boolean} isDesktop - desktop viewport flag
 * @param {string} sectionType - section id
 * @returns {boolean} whether section should be open
 */
function getConfiguredOpenState($sectionsContainer, isDesktop, sectionType) {
    const viewportKey = isDesktop ? 'desktop' : 'mobile';
    const fallback = isDesktop && DEFAULT_OPEN_SECTIONS.indexOf(sectionType) > -1;
    const rawConfig = $sectionsContainer.attr('data-open-state');
    let config = {};

    if (rawConfig) {
        try {
            config = JSON.parse(rawConfig);
        } catch (error) {
            config = {};
        }
    }

    const viewportConfig = config[viewportKey] || {};
    const configuredValue = viewportConfig[sectionType];

    if (typeof configuredValue !== 'boolean') return fallback;

    return configuredValue;
}

/**
 * Initializes default open states based on viewport.
 * @param {jQuery} [$container] - optional container scope
 */
function initProductAttributeSections($container) {
    let $root = $('.js-product-attribute-sections');

    if ($container && $container.length) $root = $container.is('.js-product-attribute-sections') ? $container : $container.find('.js-product-attribute-sections');

    const isDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

    $root.each(function () {
        const $sectionsContainer = $(this);

        $sectionsContainer.find('.product-attribute-section').each(function () {
            const $section = $(this);
            const sectionType = $section.data('section');
            let shouldBeOpen = getConfiguredOpenState($sectionsContainer, isDesktop, sectionType);

            if (preservedOpenStates && preservedOpenStates[sectionType]) shouldBeOpen = preservedOpenStates[sectionType];

            setSectionOpen($section, shouldBeOpen);
        });
    });
}

module.exports = {
    initProductAttributeSections: initProductAttributeSections,

    handleSectionToggle: function () {
        $('body').on('click', '.product-attribute-section__trigger', function (event) {
            event.preventDefault();

            const $section = $(this).closest('.product-attribute-section');

            setSectionOpen($section, !$section.hasClass('is-open'));
        });
    },

    preserveOpenStatesOnVariationChange: function () {
        let pendingAttributeSelects = 0;

        $('body').on('product:beforeAttributeSelect', function () {
            if (pendingAttributeSelects === 0) {
                const openStates = {};

                $('.js-product-attribute-sections .product-attribute-section').each(function () {
                    const sectionType = $(this).data('section');

                    if (sectionType) openStates[sectionType] = $(this).hasClass('is-open');
                });

                preservedOpenStates = openStates;
            }

            pendingAttributeSelects += 1;
        });

        $('body').on('product:afterAttributeSelect', function () {
            pendingAttributeSelects = Math.max(0, pendingAttributeSelects - 1);
        });
    },

    initOnReady: function () {
        initProductAttributeSections();
    }
};
